import React from 'react'
import { TableProps } from './table.model'

import 'ag-grid-community/styles/ag-grid.css' // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css' // Theme
import './styles/index.scss'
import TableProvider from './components/TableProvider'
import TableContent from './components/TableContent'

// Create new GridExample component
const CommonTable: React.FC<TableProps> = (props) => {
  return (
    <TableProvider {...props}>
      <TableContent />
    </TableProvider>
  )
}

export default CommonTable
